/* UWC custom DTF pricing (added by Claude, Oct 2026).
   Volume savings are per DESIGN: every size of the same uploaded design counts together
   (e.g. 6 chest + 6 back of one logo = 12 = 10% off). Different designs never combine.
   Each cart line stores _Design (design id) and _Base (full price per transfer, in cents).
   The discounted price is "baked in" by picking the matching price variant of the product.
   normalize() re-checks every custom line in the cart and re-prices lines whose design total
   has changed (for example after adding another size, or removing one in the cart). */
(function () {
  if (window.UWCDTF) return;
  var HANDLE = 'custom-dtf-transfer';
  var VOL = [[21, 0.20], [10, 0.10]];
  var STEP = 25; /* cents */
  function discFor(qty) { for (var i = 0; i < VOL.length; i++) if (qty >= VOL[i][0]) return VOL[i][1]; return 0; }
  function tierPrice(base, qty) {
    var d = discFor(qty); if (!d) return base;
    return Math.round(base * (1 - d) / STEP) * STEP;
  }
  var productP = null;
  function product() {
    if (!productP) productP = fetch('/products/' + HANDLE + '.js').then(function (r) { return r.json(); });
    return productP;
  }
  function variantFor(p, cents) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].price === cents) return p.variants[i]; return null; }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function groups(cart, pid) {
    var g = {};
    cart.items.forEach(function (i) {
      if (i.product_id !== pid) return;
      var id = (i.properties && i.properties._Design) || i.key;
      g[id] = (g[id] || 0) + i.quantity;
    });
    return g;
  }
  /* Re-price custom lines whose design total changed. Resolves true if anything changed. */
  function normalize() {
    return Promise.all([product(), getCart()]).then(function (res) {
      var p = res[0], cart = res[1], g = groups(cart, p.id), todo = [];
      cart.items.forEach(function (i) {
        if (i.product_id !== p.id || !i.properties || !i.properties._Base) return;
        var want = tierPrice(parseInt(i.properties._Base, 10), g[i.properties._Design || i.key]);
        if (want !== i.price) { var v = variantFor(p, want); if (v) todo.push({ line: i, v: v }); }
      });
      return todo.reduce(function (chain, t) {
        return chain
          .then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: t.line.key, quantity: 0 }) }); })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: t.v.id, quantity: t.line.quantity, properties: t.line.properties }] }) }); });
      }, Promise.resolve()).then(function () { return todo.length > 0; });
    });
  }
  window.UWCDTF = { HANDLE: HANDLE, VOL: VOL, discFor: discFor, tierPrice: tierPrice, product: product, variantFor: variantFor, getCart: getCart, groups: groups, normalize: normalize };

  /* On the cart page: keep prices right if a customer removes one size of a design. */
  if (/^\/cart\/?$/.test(location.pathname)) {
    var run = function () { normalize().then(function (changed) { if (changed) location.reload(); }).catch(function () {}); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cart-page-delete], [data-ajax-cart-delete]')) setTimeout(run, 1500);
    }, true);
  }
})();
